export default [
  {
    leistungstext: "Personen-, Sach- und Vermögensschäden",
    infoText:
      "Übernahme von Schadenersatzansprüchen für beschädigte Sachen oder finanzielle Schäden eines Dritten bzw. für Schäden an Personen.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Schneeräum- und Bestreuungsrisiko",
    infoText: "Schadenersatzansprüche durch unzureichendes Räumen und Streuen der Grundstücksflächen.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Sachschäden durch allmähliche Einwirkung von bspw. Feuchtigkeit",
    infoText:
      "Allmählichkeitsschäden entstehen, oftmals unbemerkt, über einen längeren Zeitraum und können teilweise hohe Kosten verursachen. Beispielsweise sinkt infolge von Erdarbeiten ein angrenzendes Gebäude allmählich ab und infolgedessen entstehen schwerwiegende Schäden an mehreren Wohneinheiten.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Bauherrenrisiko bis zu einer Bausumme von",
    infoText: "Übernahme der gesetzlichen Haftpflicht als Bauherr oder Unternehmer von Bauarbeiten.",
    leistungen: ["250.000 €", "350.000 €"],
  },
  {
    leistungstext: "Gewässerschadenrisiko eines ober- oder unterirdischen Öltanks bis zu einem Fassungsvermögen von",
    infoText: "Gewässerschäden durch einen Öltank, unabhängig vom Aufstellort.",
    leistungen: ["5.000 Liter", "10.000 Liter"],
  },
  {
    leistungstext: "Photovoltaikanlagen",
    infoText:
      "Mitversichert sind die Verkehrssicherungspflicht sowie die Einspeisung von Strom als Besitzer einer Photovoltaikanlage.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Vorsorgeversicherung für neue Risiken",
    infoText:
      "Beitragsfreie Mitversicherung einer hinzukommenden Wohn- oder Gewerbeeinheit bis zur nächsten Beitragsrechnung (Hauptfälligkeit)",
    leistungen: ["Bis 250.000 €", "Bis 1.000.000 €"],
  },
  {
    leistungstext: "Forderungsausfall für Mietsachschäden",
    infoText: "Übernahme von uneinbringlichen Schadenersatzforderungen gegenüber einem Mieter",
    leistungen: ["Ja (SB 10 % mind. 500 €)", "Ja"],
  },
  {
    leistungstext: "Leistungsstarker GEV-Versicherungsschutz bereits vor Vertragsbeginn",
    infoText:
      "Sie profitieren von den bei uns zusätzlich abgeschlossenen Leistungen schon vor Vertragsbeginn, sofern die Leistungen Ihrer bestehenden Versicherung nicht ausreichen",
    leistungen: ["Nein", "Ja"],
  },
];
